import { IdCardsComponent } from '../../../../../routes/id-cards/id-cards.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { IdCardService } from '@services/id-card.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, IdCardsComponent],
  selector: 'app-dash-id-card',
  templateUrl: './dash-id-card.component.html',
  styleUrls: ['./dash-id-card.component.scss']
})
export class DashIdCardComponent implements OnInit {
  @Input() policy: any;
  @Input() activePolicyArray: any[];
  @Input() index: number;
  isAcmic: boolean;
  vehEligibleForIdCard: any[];

  constructor(
    private acmicService: AcmicService,
    private idCardService: IdCardService
    ) { }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.vehEligibleForIdCard = this.getVehEligibleForIdCard();
  }

  getVehEligibleForIdCard() {
    return this.policy?.vehicle 
                ? this.policy?.vehicle.filter(veh => veh.vehicleType !== 'utility_trailer') 
                : [];
  }

  getIdCardDocument(action) {
    this.idCardService.getIdCard(this.policy, action, this.policy.policynumber.policyNumber, this.vehEligibleForIdCard);
  }
}
